import { render, staticRenderFns } from "./EvaluacionesIndex.vue?vue&type=template&id=dd2438ee"
import script from "./EvaluacionesIndex.vue?vue&type=script&lang=js"
export * from "./EvaluacionesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports